import { render, staticRenderFns } from "./SelecoesInscricoes.vue?vue&type=template&id=9f2ea600&scoped=true"
import script from "./SelecoesInscricoes.vue?vue&type=script&lang=js"
export * from "./SelecoesInscricoes.vue?vue&type=script&lang=js"
import style0 from "./SelecoesInscricoes.vue?vue&type=style&index=0&id=9f2ea600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2ea600",
  null
  
)

export default component.exports